module.exports = __webpack_public_path__ + "static/media/r10.df53459f.png";